import React from 'react'
import { Modal } from 'react-bootstrap';

const ViewPreviousTnC = ({ show, onHide, templateUrl }) => {

    return (
        <>
            {/* <Loader show={loading} /> */}
            <Modal
                size="lg"
                show={show}
                onHide={onHide}
                dialogClassName="docg-modal"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg" className="ml-3">
                        <span className="ModalTitle">Published Terms & Conditions</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {templateUrl ? (
                        <div>
                            <iframe
                                title="Published TnC"
                                src={templateUrl}
                                style={{ width: "99%", height: "500px" }}
                                frameborder="0"
                            ></iframe>
                        </div>
                    ) : (
                        <>Unable to load previous tnc</>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewPreviousTnC;